export default class ChangeUserController {
    /* @ngInject */
    constructor($scope, $state, localStorageService, $translate, ApiUser, $ionicPopup, $ionicLoading, ApiPicklist, MessageBox, $rootScope) {
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$state = $state;
        this.ApiUser = ApiUser;
        this.localStorageService = localStorageService;
        this.ApiPicklist = ApiPicklist;
        this.MessageBox = MessageBox;
        this.user = {};
        this.loading = [];
        this.$rootScope = $rootScope;
        this.isPurchase = false;
    }

    init() {
        this.getUser();
        this.getCountries();
        this.getEuropeanCountryList();
    }

    showLoading() {
        this.loading.push(1);
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });
    }

    hideLoading() {
        this.loading.pop();
        if (this.loading.length <= 0) {
            this.$ionicLoading.hide();
        }
    }

    getUser() {
        this.showLoading();
        this.ApiUser.getUser().then((res) => {
            if (typeof res != 'undefined') {
                this.user = res;
                this.hideLoading();
            } else {
                this.hideLoading();
            }
        });
    }

    getCountries() {
        this.showLoading();
        this.ApiPicklist.getAdvindaCountries().then((countries) => {
            this.contactCountries = countries.data.sort();
            this.hideLoading();
        });
    }

    changeUser() {
        this.showLoading();
        this.ApiUser.changeUser(this.user, this.isPurchase).then((res) => {
            this.hideLoading();
            this.$rootScope.user = res;
            if (res) {
              this.$state.go('user');
            }
        });
    }

    getEuropeanCountryList(){
        this.showLoading();
        this.ApiPicklist.getEuropeanUnionCountries().then((countries) => {
            this.europeanCountries = countries.data.sort();
            this.hideLoading();
        });
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/user/changeUser.controller.js
 **/